<div class="container">
    <nav class="navbar navbar-custom navbar-expand-lg bg-white">
        <a class="navbar-brand" href="#">
            <img src="../assets/images/logo-cn.svg" width="100" alt="">
        </a>
        <button class="navbar-toggler">
            <span class="toggle-icon-line"></span>
            <span class="toggle-icon-line"></span>
            <span class="toggle-icon-line"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        御成大道
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" href="#">初心</a>
                        <a class="dropdown-item" href="#">無華</a>
                        <a class="dropdown-item" href="#">樸質</a>
                        <a class="dropdown-item" href="#">細藏</a>
                    </div>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        雙手聯彈
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" href="#">初心</a>
                        <a class="dropdown-item" href="#">無華</a>
                        <a class="dropdown-item" href="#">樸質</a>
                        <a class="dropdown-item" href="#">細藏</a>
                    </div>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        敦年中山
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" href="#">初心</a>
                        <a class="dropdown-item" href="#">無華</a>
                        <a class="dropdown-item" href="#">樸質</a>
                        <a class="dropdown-item" href="#">細藏</a>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
</div>